// Shared duotone functional glyphs; color never replaces a visible status label.
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type AdminIconTone = 'brand' | 'success' | 'warning' | 'neutral';
const tones: Record<AdminIconTone, string> = {
  brand: 'bg-primary-soft-bg text-primary-soft-fg',
  success: 'bg-severity-success-bg text-severity-success-fg',
  warning: 'bg-severity-warn-bg text-severity-warn-fg',
  neutral: 'bg-surface-2 text-muted-foreground',
};

export function AdminIcon({ icon: Icon, tone = 'brand', className }: { icon: LucideIcon; tone?: AdminIconTone; className?: string }) {
  return <span aria-hidden className={cn('inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl', tones[tone], className)}>
    <Icon className="h-[23px] w-[23px]" strokeWidth={2.3} fill="currentColor" fillOpacity={0.16} />
  </span>;
}
